(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["favorite"] && !Shopify.designMode) return;
  try {
    const btn = document.getElementById("wishlist-button");

    if(!btn) {
        return;
    }

    btn.addEventListener("click", 
        function() {
            this.classList.toggle('is-active');
            const svg = this.querySelector('svg');
            if (this.classList.contains('is-active')) {
                svg.style.fill = '#e74c3c';
                svg.style.stroke = '#e74c3c';
                this.style.borderColor = '#e74c3c';
                console.log('Added to wishlist:', this.dataset.productId);
            } else {
                svg.style.fill = 'none';
                svg.style.stroke = 'currentColor';
                this.style.borderColor = 'rgba(0,0,0,0.1)';
                console.log('Removed from wishlist:', this.dataset.productId);
            }
        }
    )
  } catch(e) { console.error(e); }
})();

})();
